import React from "react";
import { useSelector } from "react-redux";
import drutasLogo from "../../../assets/images/drutas-logo-white-d.png";
import SidebarSkeleton from "./SidebarSkeleton";
import MainHeaderSkeleton from "./MainHeaderSkeleton";
import "./suspenseFallback.scss";

const SuspenseFallback = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const mockSendCollapse = () => {};

  return (
    <div className='suspense-fallback'>
      {isAuthenticated && <SidebarSkeleton />}
      <div className='suspense-fallback__main'>
        {isAuthenticated && <MainHeaderSkeleton />}
        <div className='loader'>
          <img src={drutasLogo} alt='Drutas Logo' />
        </div>
      </div>
    </div>
  );
};

export default SuspenseFallback;
